import Markdown from 'react-markdown';
import { TrackSectionView } from '../common/TrackSectionView.tsx';

export const MarketingFAQ = ({faqs}) => {

    return (
            <div className='faq'>
                <div className="container">
                    <h3>Frequently Asked Questions</h3>
                    <div className="question-container">
                    <TrackSectionView sectionName='FAQs'>
                        {faqs.map((faq, index) =>
                            <div className='single-question'>
                                <h3><strong>{faq.faq}</strong></h3>
                                <p>{faq.answer}</p>
                            </div>
                        )}
                    </TrackSectionView>
                    </div>
                </div>
            </div>
    )
}
